function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null);

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M 29.554,20.123133 V 52.888077",
  strokeWidth: 4.84208,
  strokeLinecap: "round",
  fillRule: "evenodd",
  id: "path1522"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m 29.04,18.87956 -12.99,-10.024 0.523,-6.352 6.366,0.325 6.533,7.874 z",
  strokeWidth: 1.33333,
  fillRule: "evenodd",
  id: "path1524"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m 29.554,20.27856 h -14.5 l -4.5,-4.5 4.5,-4.5 h 14.5 z",
  strokeWidth: 1.33333,
  id: "path1526"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m 29.554,11.27856 h 14.5 l 4.5,4.5 -4.5,4.5 h -14.5 z",
  strokeWidth: 1.33333,
  id: "path1528"
});

function SvgWayfinding(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 56.9 56.9",
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWayfinding);
export default __webpack_public_path__ + "static/media/wayfinding.a69f5d44.svg";
export { ForwardRef as ReactComponent };